import React from 'react';
import './ComparisonTables.css';

const ComparisonTables = () => {
  return (
    <section className="comparison-section" id="comparison">
      <div className="landing-container-full">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">Why Choose Utility Tools?</h2>
          <p className="section-description">
            See how our free, browser-based PDF tools compare to other solutions
          </p>
        </div>

        {/* Premium Comparison Table */}
        <div className="premium-comparison">
          <div className="comparison-container">
            <table className="premium-table">
              <thead>
                <tr className="table-header">
                  <th className="feature-header"></th>
                  <th className="solution-header">
                    <div className="solution-card">
                      <div className="solution-title">Other Tools</div>
                      <div className="solution-price">$5-15/mo</div>
                    </div>
                  </th>
                  <th className="solution-header">
                    <div className="solution-card">
                      <div className="solution-title">Desktop Apps</div>
                      <div className="solution-price">$100-300</div>
                    </div>
                  </th>
                  <th className="solution-header premium">
                    <div className="solution-card premium-card">
                      <div className="solution-title">Utility Tools</div>
                      <div className="solution-price free">Free Forever</div>
                      <div className="premium-badge">Recommended</div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="comparison-row">
                  <td className="feature-cell">
                    <div className="feature-label">Privacy & Security</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator poor">Server Upload</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator good">Local Processing</div>
                  </td>
                  <td className="value-cell premium-cell">
                    <div className="value-indicator excellent">100% Browser-Only</div>
                  </td>
                </tr>
                <tr className="comparison-row">
                  <td className="feature-cell">
                    <div className="feature-label">Processing Speed</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator poor">Upload Delays</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator good">Fast Processing</div>
                  </td>
                  <td className="value-cell premium-cell">
                    <div className="value-indicator excellent">Instant</div>
                  </td>
                </tr>
                <tr className="comparison-row">
                  <td className="feature-cell">
                    <div className="feature-label">Installation</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator good">No Install</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator poor">Large Downloads</div>
                  </td>
                  <td className="value-cell premium-cell">
                    <div className="value-indicator excellent">Any Browser</div>
                  </td>
                </tr>
                <tr className="comparison-row">
                  <td className="feature-cell">
                    <div className="feature-label">File Size Limits</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator poor">2-5MB Only</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator good">No Limits</div>
                  </td>
                  <td className="value-cell premium-cell">
                    <div className="value-indicator excellent">Up to 10MB</div>
                  </td>
                </tr>
                <tr className="comparison-row">
                  <td className="feature-cell">
                    <div className="feature-label">Batch Processing</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator poor">Premium Only</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator good">Available</div>
                  </td>
                  <td className="value-cell premium-cell">
                    <div className="value-indicator excellent">Unlimited</div>
                  </td>
                </tr>
                <tr className="comparison-row">
                  <td className="feature-cell">
                    <div className="feature-label">Offline Support</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator poor">Internet Required</div>
                  </td>
                  <td className="value-cell">
                    <div className="value-indicator good">Works Offline</div>
                  </td>
                  <td className="value-cell premium-cell">
                    <div className="value-indicator excellent">After First Load</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Summary CTA */}
          <div className="comparison-summary">
            <div className="summary-content">
              <h3>Why Utility Tools Wins</h3>
              <ul className="winning-points">
                <li><span className="point-icon">💚</span> Completely free with no hidden costs</li>
                <li><span className="point-icon">🔐</span> Your files never leave your device</li>
                <li><span className="point-icon">🚀</span> Instant processing with no uploads</li>
                <li><span className="point-icon">🌟</span> Professional features without limitations</li>
              </ul>
              <div className="summary-cta">
                <button
                  className="cta-button"
                  onClick={() => document.getElementById('tools-showcase').scrollIntoView({ behavior: 'smooth' })}
                >
                  Try It Now - It's Free!
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Tool Selection Guide */}
        <div className="tool-selection-guide">
          <h3 className="guide-title">Which Tool Should You Use?</h3>
          <div className="tool-comparison-grid">
            <div className="tool-comparison-card">
              <div className="tool-header pdf-converter">
                <span className="tool-icon">📄</span>
                <h4>PDF Converter</h4>
              </div>
              <div className="tool-content">
                <div className="best-for">
                  <h5>Best for:</h5>
                  <ul>
                    <li>Converting images to PDF</li>
                    <li>Document digitization</li>
                    <li>Creating PDF portfolios</li>
                    <li>Merging different file types</li>
                  </ul>
                </div>
                <div className="supported-formats">
                  <h5>Input Formats:</h5>
                  <div className="format-tags">
                    <span className="format-tag">JPG</span>
                    <span className="format-tag">PNG</span>
                    <span className="format-tag">DOCX</span>
                    <span className="format-tag">TXT</span>
                    <span className="format-tag">+5 more</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="tool-comparison-card">
              <div className="tool-header page-remover">
                <span className="tool-icon">🗑️</span>
                <h4>PDF Page Remover</h4>
              </div>
              <div className="tool-content">
                <div className="best-for">
                  <h5>Best for:</h5>
                  <ul>
                    <li>Removing unwanted pages</li>
                    <li>Extracting specific pages</li>
                    <li>Reducing file size</li>
                    <li>Document cleanup</li>
                  </ul>
                </div>
                <div className="supported-formats">
                  <h5>Input Formats:</h5>
                  <div className="format-tags">
                    <span className="format-tag">PDF</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Security Highlight */}
        <div className="security-highlight">
          <div className="security-content">
            <div className="security-icon">
              <span>🔒</span>
            </div>
            <div className="security-text">
              <h4>Your Files Never Leave Your Device</h4>
              <p>Unlike other online tools, we process everything in your browser. No uploads, no data collection, complete privacy guaranteed.</p>
            </div>
            <div className="security-badges">
              <div className="security-badge">
                <span className="badge-icon">🛡️</span>
                <span>GDPR Compliant</span>
              </div>
              <div className="security-badge">
                <span className="badge-icon">🔐</span>
                <span>Zero Data Collection</span>
              </div>
              <div className="security-badge">
                <span className="badge-icon">⚡</span>
                <span>Instant Processing</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTables;